import React, { useEffect, useState } from 'react'
import '../../Products/Product.css';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import factorydata from './factorydata';
import showroomdata from './showroomdata';
import FooterContact from '../../extracomponents/FooterContact';
import ProductRange from '../../extracomponents/ProductRange';
import ProductHeader from '../../extracomponents/ProductHeader';
import Productcategory from '../../extracomponents/Productcategory';
import Footer from '../../Footer/Footer';
import Header from '../../Header/Header';
import imgbg from "../../images/exhibitions/(1).jpeg"


const Infrastructure = () => {

    const bgstyle = {

        height: "60vh",
        // margin: "50px",
        // backgroundPosition: "center",
        // backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        background: `linear-gradient(180deg, rgba(0, 0,0, 0.7), rgba(2, 0, 0, .7)), url("${imgbg}")`
        // backgroundImage: `url(${imgbg})`
        // backgroundImage: `url(${imgbg})`


    }
//     const bg2style ={
        
//         height: "10vh",
//         margin:"50px",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "cover",
//         backgroundImage:"linear-gradient(180deg, rgba(0, 0,0, 0.3), rgba(2, 0, 0, .5)), url(../../images/BRAID_RUG/rug1-min.jpg)"
//         // backgroundImage:"linear-gradient(to right, rgba(255,0,0,0), rgba(255,0,0,1))"
        
      
// }
    const [spinner, setspinner] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0)
        setTimeout(() => {
            setspinner(false)
        }, 500);

    }, []);

    const navbraanimate = () => {
        // window.addEventListener("scroll",function(){
        //     const header = document.querySelector('header');
        //     header.classList.toggle('sticky',window.scrollY > 0);
        // });
        const navigation = document.querySelector('nav');

        document.querySelector('.toggle').onclick = function () {
            this.classList.toggle('active');
            navigation.classList.toggle('active');
        }
    }
    return <>
        {
            !spinner && <div>
                {/* Sticky Navbar With Animation Effect */}
                <Header />

                <div className='bg d-flex justify-content-center' style={bgstyle}>
                    <div className="row gx-0 align-items-center ">
                        <div className="col-12 text-center  text-white" >
                            <h1>Infrastructure</h1>
                        {/* <h5>We are very active within the home décor industry. Here is a glimpse into some of the exhibitions and showcase events we’ve been to…</h5> */}
                        </div>

                    </div>

                </div>

                <div className='bg'>
                    <div className="row gx-0 d-flex justify-content-center ">
                        <div className="col-12 text-center " >
                            <h1 style={{color:"#7D7D7D"}}>Factory</h1>
                        {/* <h5>We are very active within the home décor industry. Here is a glimpse into some of the exhibitions and showcase events we’ve been to…</h5> */}
                        </div>

                    </div>

                </div>


                {/* Gallery==== */}
                {/* <section className="text-center ">

                    <h2>Exhibitions</h2>
                    <div className="row d-flex justify-content-center">
                        <div className="col-8 text-center">

                            <h5>We are very active within the home décor industry. Here is a glimpse into some of the exhibitions and showcase events we’ve been to…</h5>
                        </div>
                    </div>
                </section> */}
                <div class="container py-5">
                    <div class="gallery">
                        {
                            factorydata.map((item) => (
                                <>
                                    <a href={item.imgsrc}
                                        data-lightbox="models" data-title="Caption1">
                                        <LazyLoadImage
                                            // alt={image.alt}
                                            effect="blur"
                                            src={item.imgsrc}

                                        />

                                    </a>

                                </>
                            ))
                        }




                    </div>
                </div>





                <div className='bg' >
                    <div className="row gx-0 d-flex justify-content-center ">
                        <div className="col-12 text-center " >
                            <h1 style={{color:"#7D7D7D"}}>Showroom</h1>
                        {/* <h5>We are very active within the home décor industry. Here is a glimpse into some of the exhibitions and showcase events we’ve been to…</h5> */}
                        </div>

                    </div>

                </div>
                <div class="container py-5">
                    <div class="gallery">
                        {
                            showroomdata.map((item) => (
                                <>
                                    <a href={item.imgsrc}
                                        data-lightbox="models" data-title="Caption1">
                                        <LazyLoadImage
                                            // alt={image.alt}
                                            effect="blur"
                                            src={item.imgsrc}

                                        />

                                    </a>

                                </>
                            ))
                        }




                    </div>
                </div>
                {/* Gallery==== */}

                {/* Cards Animated=== */}

                {/* {Scroll Bar Cards}    */}
                {/* <ProductRange/> */}
                {/* <Productcategory /> */}
                {/* {Scroll Bar Cards}    */}

                {/* Cards Animated=== */}


                {/* You Tube==== */}
               <div className="d-flex justify-content-center py-5">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/03nFzkrAALA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>               </div>
                {/* You Tube==== */}
            


                {/* Contact=== */}
                <FooterContact />
                {/* Contact=== */}
                <Footer />



            </div>
        }
    </>
};

export default Infrastructure;
